import { createSlice } from "@reduxjs/toolkit";

const countrySlice = createSlice({
  name: "country",
  initialState: {
    selectedCountry: "egypt", // Default country
    countries: [
      { id: "egypt", name: "مصر", nameEn: "Egypt", flag: "🇪🇬" },
      { id: "saudi", name: "السعودية", nameEn: "Saudi Arabia", flag: "🇸🇦" },
    ],
  },
  reducers: {
    setCountry(state, action) {
      state.selectedCountry = action.payload;
    },
  },
});

export const { setCountry } = countrySlice.actions;
export default countrySlice.reducer;
